module.exports = __webpack_public_path__ + "static/edit-theme-files-696d17dd20dbe840af63ff1625b95bfa.png";